import './scripts/initialize';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import FormLabel from './components/Form/FormLabel';
import FormInput from './components/Form/FormInput';
import FormGroup from './components/Form/FormGroup';

const app = createApp(App);

app.use(router)
app.use(store)

app.component('FormLabel', FormLabel);
app.component('FormInput', FormInput);
app.component('FormGroup', FormGroup);

app.mount('#app')
